/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Assessment_Reference_Method_Dxa_Same_MachineInputs */

const en_us2_body_assessment_reference_method_dxa_same_machine = /** @type {(inputs: Body_Assessment_Reference_Method_Dxa_Same_MachineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DXA, always the same machine`)
};

const pt_br2_body_assessment_reference_method_dxa_same_machine = /** @type {(inputs: Body_Assessment_Reference_Method_Dxa_Same_MachineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DEXA, sempre no mesmo aparelho`)
};

const es_419_body_assessment_reference_method_dxa_same_machine = /** @type {(inputs: Body_Assessment_Reference_Method_Dxa_Same_MachineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DXA, siempre en el mismo equipo`)
};

const pt_pt2_body_assessment_reference_method_dxa_same_machine = /** @type {(inputs: Body_Assessment_Reference_Method_Dxa_Same_MachineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DEXA, sempre no mesmo aparelho`)
};

const fr_fr2_body_assessment_reference_method_dxa_same_machine = /** @type {(inputs: Body_Assessment_Reference_Method_Dxa_Same_MachineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DXA, toujours sur le même appareil`)
};

const de_de2_body_assessment_reference_method_dxa_same_machine = /** @type {(inputs: Body_Assessment_Reference_Method_Dxa_Same_MachineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DXA, immer dasselbe Gerät`)
};

const it_it2_body_assessment_reference_method_dxa_same_machine = /** @type {(inputs: Body_Assessment_Reference_Method_Dxa_Same_MachineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DXA, sempre con lo stesso apparecchio`)
};

/**
* | output |
* | --- |
* | "DXA, always the same machine" |
*
* @param {Body_Assessment_Reference_Method_Dxa_Same_MachineInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_assessment_reference_method_dxa_same_machine = /** @type {((inputs?: Body_Assessment_Reference_Method_Dxa_Same_MachineInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Assessment_Reference_Method_Dxa_Same_MachineInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_assessment_reference_method_dxa_same_machine(inputs)
	if (locale === "es-419") return es_419_body_assessment_reference_method_dxa_same_machine(inputs)
	if (locale === "pt-PT") return pt_pt2_body_assessment_reference_method_dxa_same_machine(inputs)
	if (locale === "fr-FR") return fr_fr2_body_assessment_reference_method_dxa_same_machine(inputs)
	if (locale === "de-DE") return de_de2_body_assessment_reference_method_dxa_same_machine(inputs)
	if (locale === "it-IT") return it_it2_body_assessment_reference_method_dxa_same_machine(inputs)
	return en_us2_body_assessment_reference_method_dxa_same_machine(inputs)
});
export { body_assessment_reference_method_dxa_same_machine as "body-assessment.reference_method.dxa_same_machine" }